import { render, staticRenderFns } from "./PatientSurgery.vue?vue&type=template&id=2ed51af1&scoped=true"
import script from "./PatientSurgery.vue?vue&type=script&lang=js"
export * from "./PatientSurgery.vue?vue&type=script&lang=js"
import style0 from "./PatientSurgery.vue?vue&type=style&index=0&id=2ed51af1&prod&scoped=true&lang=css"
import style1 from "./PatientSurgery.vue?vue&type=style&index=1&id=2ed51af1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed51af1",
  null
  
)

export default component.exports